import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import "./Login.css";
import axios from "axios";
import { getNewCapSignup, setNewCapSignup, setUserSession } from '../utils/Common';
import LoaderButton from '../components/LoaderButton';

//TODO: Move api calls out of this file

export default function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const canSubmit = email.trim().length > 0 && password.length > 0;

  useEffect(() => {
    if(props.location && props.location.state && props.location.state.signupnewcap) {
      setNewCapSignup(true);
    }
  }, []);

  function handleLoginError(error) {
    console.log(error);
    props.setShowError(true);
    props.setErrorStatus("error-message");
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      props.setErrorMessage("Invalid email or password. Please try again.");
    } else {
      props.setErrorMessage("We're currently experiencing an issue with our servers. We're working on a fix and should be back shortly. Please try again in a few minutes.");
    }
    setIsLoading(false);
  }

  function handleLogin(event) {
    event.preventDefault();
    if(!canSubmit) return;

    setIsLoading(true);
    const fixedEmail = email.trim().toLowerCase();

    axios.post(
      `${process.env.REACT_APP_API_URL}/users/login`,
      {"email": fixedEmail, "password": password},
      {headers: {'Content-Type': 'application/json', 'accept': 'application/json'}}
    ).then(response => {
      const config = {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${response.data.token}`
        }
      };
      axios.get(
        `${process.env.REACT_APP_API_URL}/users/me`,
        config
      ).then(response2 => {
        props.setShowError(false);
        setUserSession(response.data.token, response2.data);
        console.log('Login successful, redirecting to:', {
          hasNewCapSignup: getNewCapSignup(),
          hasLocationState: !!props.location.state,
          fromLocation: props.location.state?.from,
          userRole: response2.data.role
        });
        if(getNewCapSignup()) {
          props.history.push('/signupnewcap');
        } else if(props.location.state && props.location.state.from && props.location.state.from.pathname) {
          console.log('Redirecting to saved location:', props.location.state.from);
          props.history.push(props.location.state.from);
        } else {
          console.log('No saved location, redirecting to default dashboard');
          props.history.push("/dashboard");
        }
        setIsLoading(false);
      }).catch(handleLoginError);
    }).catch(handleLoginError);
  }

  return (
    <div className="login-page">
      <header className="login-header">
        <h1>Log In</h1>
        <p className="login-subtitle">
          Sign in to access your Bedrock Wireless cameras.
        </p>
      </header>

      <div className="login-panel">
        <form className="login-form" onSubmit={handleLogin}>
          <FormGroup controlId="email">
            <ControlLabel>Email</ControlLabel>
            <FormControl
              autoFocus
              type="email"
              autoComplete="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="password">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </FormGroup>
          <div className="login-actions">
            <LoaderButton
              block
              type="submit"
              className="btn-brand-dark"
              bsSize="large"
              isLoading={isLoading}
              disabled={!canSubmit}
            >
              Log In
            </LoaderButton>
            <Link className="login-link" to="/passwordreset">Forgot your password?</Link>
            <p className="login-footer">
              New user? <Link to="/signup">Sign up</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
